import { create } from 'zustand';

export enum Languages {
  zh = 'zh',
  en = 'en',
}

interface LangStore {
  lang: Languages;
  changeLanguage: (lang: Languages) => void;
  toggleLanguage: () => void;
}

export const useLanguageStore = create<LangStore>((set, get) => ({
  lang: Languages.zh, // en
  changeLanguage: (lang) => {
    localStorage.setItem('lang', lang);
    set(() => ({ lang }));
  },
  toggleLanguage: () => {
    const { lang } = get();
    const nextLang = lang === Languages.zh ? Languages.en : Languages.zh;
    localStorage.setItem('lang', nextLang);
    set(() => ({ lang: nextLang }));
  },
}));
